export const COMMENTS_FETCH_ALL = 'COMMENTS_FETCH_ALL'
export const COMMENTS_FETCH_BY_SEARCH = 'COMMENTS_FETCH_BY_SEARCH'
export const COMMENTS_FETCH_POST = 'COMMENTS_FETCH_POST'
export const COMMENTS_NEW_POST_FORM_HIDDEN = 'COMMENTS_NEW_POST_FORM_HIDDEN'
export const COMMENTS_NEW_POST_FORM_LINK = 'COMMENTS_NEW_POST_FORM_LINK'
export const COMMENTS_NEW_POST_FORM_QUESTION = 'COMMENTS_NEW_POST_FORM_QUESTION'
export const COMMENTS_NEW_POST_FORM_DISCUSSION = 'COMMENTS_NEW_POST_FORM_DISCUSSION'
export const COMMENTS_NEW_POST_FORM_ERRATA = 'COMMENTS_NEW_POST_FORM_ERRATA'
export const COMMENT_QUESTION = 'COMMENT_QUESTION'
export const COMMENT_LINK = 'COMMENT_LINK'
export const COMMENT_DISCUSSION= 'COMMENT_DISCUSSION'
export const COMMENT_ERRATA = 'COMMENT_ERRATA'
export const COMMENT_EXPLAIN = 'COMMENT_EXPLAIN'
export const COMMENT_UNKNOWN = 'COMMENT_UNKNOWN'
